import { h } from "preact";
import { useState } from "preact/hooks";
import { QuantityMinus, QuantityPlus } from "../../helpers/icons";

export default function MiniCartQuantity({ item, max }) {
  const [quantity, setQuantity] = useState(item.quantity);
  const [pendingRequests, setPendingRequests] = useState([]);

  if (pendingRequests.length === 0 && item.quantity !== quantity) {
    setQuantity(item.quantity);
  }

  const updateQuantity = (quantity) => {
    setQuantity(quantity);
    const requestId = window.crypto.randomUUID();
    setPendingRequests([...pendingRequests, requestId]);
    window.updateCart(
      { updates: { [item.id]: quantity } },
      {
        onAfterAdd: (data) => {
          const newItem = data.items.find(({ id }) => id === item.id);

          if (!newItem) return;

          if (newItem.quantity !== quantity) {
            setQuantity(newItem.quantity);
          }

          setPendingRequests(
            pendingRequests.filter((request) => request !== requestId),
          );
        },
      },
    );
  };

  return (
    <div className="quantity">
      <button
        className="quantity__button quantity__button--decrease"
        name="minus"
        type="button"
        onClick={() => updateQuantity(quantity - 1)}
      >
        <span className="visually-hidden">
          {window.localeStrings.product.quantity_decrease}
        </span>
        <QuantityMinus />
      </button>
      <label className="quantity__input-label">
        <span className="visually-hidden">
          {window.localeStrings.product.quantity}
        </span>
        <input
          className="quantity__input"
          type="number"
          name="quantity"
          min="0"
          max={max}
          step="1"
          value={quantity}
          onChange={(e) =>
            updateQuantity(
              max !== null
                ? Math.min(max, parseInt(e.target.value))
                : parseInt(e.target.value),
            )
          }
        />
      </label>
      <button
        className="quantity__button quantity__button--increase no-js-hidden"
        name="plus"
        type="button"
        disabled={max > 0 && quantity >= max}
        onClick={() => updateQuantity(quantity + 1)}
      >
        <span className="visually-hidden">
          {window.localeStrings.product.quantity_increase}
        </span>
        <QuantityPlus />
      </button>
    </div>
  );
}
